export const REPORT_DEFINITION = ['reportDefinition'];

// COLUMNS
export const COLUMNS = ['reportDefinition', 'columns'];

// VISUALS
export const VISUAL = ['reportDefinition', 'visual'];
export const VISUAL_TYPE = [...VISUAL, 'type'];
export const VISUAL_OPTIONS = [...VISUAL, 'options'];
const VISUAL_OPTIONS_COLOR = [...VISUAL_OPTIONS, 'color'];
export const VISUAL_OPTIONS_Y1COLOR = [...VISUAL_OPTIONS, 'y1Color'];
export const VISUAL_OPTIONS_Y2COLOR = [...VISUAL_OPTIONS, 'y2Color'];

// TABLE
const TABLE = ['reportDefinition', 'table'];
export const TABLE_NAME = [...TABLE, 'name'];
export const DATASET_ID = [...TABLE, 'datasetId'];

// FILTERING
export const FILTERING = ['reportDefinition', 'filtering'];
export const KEY_PATHS = {
  REPORT_DEFINITION,
  // COLUMNS
  COLUMNS,
  // TABLE
  TABLE,
  TABLE_NAME,
  DATASET_ID,
  // VISUALS
  VISUAL,
  VISUAL_TYPE,
  VISUAL_OPTIONS,
  VISUAL_OPTIONS_COLOR,
  VISUAL_OPTIONS_Y1COLOR,
  VISUAL_OPTIONS_Y2COLOR,
  // FILTERING
  FILTERING
};